<script>
import FooterView from '../../shared/views/MainFooterView';
import ContactPageComponent from '../features/pages/ContactPageComponent';
import BrandLogo from '../../shared/BrandLogo.vue';

export default {
  name: 'ContactPageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
  extends: ContactPageComponent,
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto" class="active">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="public-hero">
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >Contacto</a>
        </nav>
        <h1 class="public-hero__title">¡Queremos Conocerte!</h1>
        <p class="public-hero__subtitle">Estamos aquí para ayudarte. Contáctanos por el canal que prefieras.</p>
      </div>
    </section>

    <!-- Body -->
    <main class="public-body">
      <!-- Quick links -->
      <div class="row mb-40">
        <div class="col-md-3 col-6">
          <router-link
            to="/soporte"
            class="quick-link-card"
          >
            <div class="quick-link-card__icon">
              <i class="uil uil-headphones" />
            </div>
            <h4>Centro de Ayuda</h4>
            <p>FAQ y guías</p>
          </router-link>
        </div>
        <div class="col-md-3 col-6">
          <router-link
            to="/noticias"
            class="quick-link-card"
          >
            <div class="quick-link-card__icon">
              <i class="uil uil-newspaper" />
            </div>
            <h4>Publicaciones</h4>
            <p>Blog y noticias</p>
          </router-link>
        </div>
        <div class="col-md-3 col-6">
          <router-link
            to="/mapa-del-sitio"
            class="quick-link-card"
          >
            <div class="quick-link-card__icon">
              <i class="uil uil-sitemap" />
            </div>
            <h4>Mapa del Sitio</h4>
            <p>Navega rápido</p>
          </router-link>
        </div>
        <div class="col-md-3 col-6">
          <router-link
            to="/terminos-y-condiciones"
            class="quick-link-card"
          >
            <div class="quick-link-card__icon">
              <i class="uil uil-file-alt" />
            </div>
            <h4>Términos y Políticas</h4>
            <p>Legales</p>
          </router-link>
        </div>
      </div>

      <!-- Contact info + Map -->
      <div class="row mb-40">
        <div class="col-lg-4">
          <div class="public-card">
            <div class="public-card__accent-bar" />
            <h3>Información de Contacto</h3>
            <ul class="contact-list">
              <li>
                <div class="contact-list__icon">
                  <i class="uil uil-map-marker-alt" />
                </div>
                <div>
                  <strong>Dirección</strong>
                  <p>Calzada Macristy de Hermosillo #881, República Mexicana, Mexicali, B.C.</p>
                </div>
              </li>
              <li>
                <div class="contact-list__icon">
                  <i class="uil uil-envelope" />
                </div>
                <div>
                  <strong>Correo electrónico</strong>
                  <p>hola@appmisionate.com</p>
                </div>
              </li>
              <li>
                <div class="contact-list__icon">
                  <i class="uil uil-phone" />
                </div>
                <div>
                  <strong>Teléfono</strong>
                  <p>686 125 3218</p>
                </div>
              </li>
              <li>
                <div class="contact-list__icon">
                  <i class="uil uil-clock" />
                </div>
                <div>
                  <strong>Horario de atención</strong>
                  <p>Lunes a Viernes: 8:00 AM – 6:00 PM<br>Sábado: 9:00 AM – 2:00 PM</p>
                </div>
              </li>
            </ul>
            <div class="social-icons">
              <a
                href="#"
                class="social-icon"
                aria-label="Facebook"
              ><i class="fab fa-facebook-f" /></a>
              <a
                href="#"
                class="social-icon"
                aria-label="Twitter"
              ><i class="fab fa-twitter" /></a>
              <a
                href="#"
                class="social-icon"
                aria-label="LinkedIn"
              ><i class="fab fa-linkedin-in" /></a>
              <a
                href="#"
                class="social-icon"
                aria-label="YouTube"
              ><i class="fab fa-youtube" /></a>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="public-card">
            <div class="public-card__accent-bar" />
            <h3>Ubícanos</h3>
            <div id="mapMain" />
          </div>
        </div>
      </div>
    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.mb-40 {
  margin-bottom: 40px;
}

.quick-link-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  height: 100%;

  &__icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #EEF5FC, #D6E7F8);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 22px;
      color: #0D47A1;
    }
  }

  h4 {
    font-family: 'Roboto', sans-serif;
    font-size: 0.9375rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
  }

  p {
    font-family: 'Roboto', sans-serif;
    font-size: 0.8125rem;
    color: #94a3b8;
    margin: 0;
  }

  &:hover {
    border-color: #0D47A1;
    box-shadow: 0 4px 16px rgba(13, 71, 161, 0.15);
    transform: translateY(-2px);
  }
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    gap: 14px;
    padding: 14px 0;
    border-bottom: 1px solid #f1f5f9;

    &:last-child {
      border-bottom: none;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
    background: #EEF5FC;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 18px;
      color: #0D47A1;
    }
  }

  strong {
    font-family: 'Roboto', sans-serif;
    font-size: 0.8125rem;
    font-weight: 600;
    color: #334155;
    display: block;
    margin-bottom: 2px;
  }

  p {
    font-family: 'Roboto', sans-serif;
    font-size: 0.875rem;
    color: #64748b;
    margin: 0;
    line-height: 1.5;
  }
}

.social-icons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.social-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  text-decoration: none;
  transition: all 0.2s ease;
  font-size: 16px;

  &:hover {
    background: #0D47A1;
    color: #ffffff;
  }
}

#mapMain {
  width: 100%;
  height: 350px;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 12px;
}
</style>
